<template>
    <u-textarea-outlined-tile v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-outlined-tile>
</template>

<script>
import UTextareaOutlinedTile from "@/components/publish/styles/forms/u-textarea-outlined-tile.vue";

export default {
    props: {},
    components: {
        UTextareaOutlinedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
